import { List } from 'immutable';
import { fetch, buildUrl } from 'domain/Api';
import is from 'is_js';
import { ApiCall } from 'omni-common-ui';
import { actions as progressTestsActions } from 'data/ProgressTests';

export const FETCH_STUDENT_REPORT_SUMMARY_REQUEST = 'FETCH_STUDENT_REPORT_SUMMARY_REQUEST';
export const FETCH_STUDENT_REPORT_SUMMARY_SUCCESS = 'FETCH_STUDENT_REPORT_SUMMARY_SUCCESS';
export const FETCH_STUDENT_REPORT_SUMMARY_FAILURE = 'FETCH_STUDENT_REPORT_SUMMARY_FAILURE';
export const FETCH_STUDENT_REPORT_SUMMARIES_REQUEST = 'FETCH_STUDENT_REPORT_SUMMARIES_REQUEST';
export const FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS = 'FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS';
export const FETCH_STUDENT_REPORT_SUMMARIES_FAILURE = 'FETCH_STUDENT_REPORT_SUMMARIES_FAILURE';
export const SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST =
    'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST';
export const SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS =
    'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS';
export const SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE =
    'SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE';

const buildFetchSummaryUrl = (progressReportId, studentId) =>
    buildUrl(`/unit-reports/${progressReportId}/students/${studentId}`);

export function fetchStudentReportSummaryIfNeeded(progressReportId, studentId) {
  return (dispatch, getState) => {
    const url = buildFetchSummaryUrl(progressReportId, studentId);
    const method = 'GET';
    if (! ApiCall.shouldPerform(getState(), { url, method })) {
      return false;
    }

    return fetchStudentReportSummary(progressReportId, studentId);
  };
}

export function fetchStudentReportSummary(progressReportId, studentId) {
  return (dispatch) => {
    const url = buildFetchSummaryUrl(progressReportId, studentId);
    const method = 'GET';

    return dispatch(fetchStudentReportSummaryRequest()).payload
        .then((response) => dispatch(fetchStudentReportSummarySuccess(response)))
        .catch((error) => dispatch(fetchStudentReportSummaryFailure(error)));

    function fetchStudentReportSummaryRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_REQUEST,
        payload: fetch(url),
        url,
        method,
        progressReportId,
        studentId,
      });
    }

    function fetchStudentReportSummarySuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_SUCCESS,
        payload,
        url,
        method,
        progressReportId,
        studentId,
      });
    }

    function fetchStudentReportSummaryFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARY_FAILURE,
        error,
        url,
        method,
        progressReportId,
        studentId,
      });
    }
  };
}

export function fetchStudentReportSummaries(progressReportId) {
  return (dispatch) => {
    const url = buildUrl(`/unit-reports/${progressReportId}/student-reports`);
    const method = 'GET';

    return dispatch(fetchStudentReportSummariesRequest()).payload
      .then((response) => dispatch(fetchStudentReportSummariesSuccess(response)))
      .catch((error) => dispatch(fetchStudentReportSummariesFailure(error)));

    function fetchStudentReportSummariesRequest() {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_REQUEST,
        payload: fetch(url),
        url,
        method,
        progressReportId,
      });
    }

    function fetchStudentReportSummariesSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS,
        payload,
        url,
        method,
        progressReportId,
      });
    }

    function fetchStudentReportSummariesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_STUDENT_REPORT_SUMMARIES_FAILURE,
        error,
        url,
        method,
        progressReportId,
      });
    }
  };
}

export function submitStudentReportSummaryTeacherPublish(progressReportId,
    groupId,
    readyToSubmitStudentReportIds = [], studentId = undefined) {
  return (dispatch, getState) => {
    const url = buildUrl(`/unit-reports/${progressReportId}/teacher-submits`);
    const method = 'PUT';

    const user = getState().get('singleSignOn').get('user');
    const userId = user ? user.get('profile').sub : 1;
    const progressTestPlan = getState()
      .get('rootReducer')
      .get('progressTestsPlan')
      .get(groupId)
      .data
      .find((plan) => plan.progressReportId === progressReportId);

    return dispatch(submitStudentReportSummaryTeacherPublishRequest()).payload
      .then((response) => dispatch(submitStudentReportSummaryTeacherPublishSuccess(response)))
      .catch((error) => dispatch(submitStudentReportSummaryTeacherPublishFailure(error)))
      .then(() => {
        if (is.undefined(studentId)) {
          return dispatch(fetchStudentReportSummaries(progressReportId));
        }
        return dispatch(fetchStudentReportSummary(progressReportId, studentId));
      }).then(() => {
        if (! is.existy(progressTestPlan)) {
          return;
        }
        return dispatch(progressTestsActions.fetchProgressTest(groupId, progressTestPlan));
      });

    function submitStudentReportSummaryTeacherPublishRequest() {
      if (! List.isList(readyToSubmitStudentReportIds)) {
        throw new Error('`readyToSubmitStudentReportIds` must be an Immutable.List!');
      }

      const request = fetch(url,
        {
          method,
          body: JSON.stringify({
            submittedByUserId: userId,
            readyToSubmitStudentReportIds: readyToSubmitStudentReportIds.map((id) =>
              Number.parseInt(id, 10)),
          }),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_REQUEST,
        payload: request,
        url,
        method,
        progressReportId,
        readyToSubmitStudentReportIds,
      });
    }

    function submitStudentReportSummaryTeacherPublishSuccess() {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_SUCCESS,
        url,
        method,
      });
    }

    function submitStudentReportSummaryTeacherPublishFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_STUDENT_REPORT_SUMMARY_TEACHER_PUBLISH_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/actions.js